import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';

import Box from 'ravenjs/lib/Box';
import Typography from 'ravenjs/lib/Typography';

// eslint-disable-next-line valid-jsdoc
/**
 * A simple no-data-available component for `DataGrid`
 */
function SampleDataGridNoData({ schema }) {
    // Extract the `noData` property,
    // this helps displaying a message to the user if no data is available.
    const noData = _get(schema, 'noData', 'No Data Available');
    // Render the default `NoDataComponent`.
    return (
        <Box elevation={5}>
            <Typography align="center" gutterBottom="0" type="subheading">
                {noData}
            </Typography>
        </Box>
    );
}

SampleDataGridNoData.propTypes = {
    schema: PropTypes.object,
};

SampleDataGridNoData.defaultProps = {
    schema: null,
};

export default SampleDataGridNoData;
